var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({attrs:{"round":""}},'el-button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('icon-svg',{attrs:{"icon-class":_vm.icon,"class-name":`button-icon ${_vm.className}`}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }